import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useT } from "../../i18n";
import LanguageSwitcher from "../ui/LanguageSwitcher";
import NotificationBell from "../notifications/NotificationBell";
import AccountMenu from "../ui/AccountMenu";
import { getSession } from "../../lib/auth";
import { SideNavButton } from "../ui/SideNav";

interface CompanyHeaderProps {
  companyName: string;
  verified: boolean;
  onLogout: () => void;
  menuOpen: boolean;
  onMenu: () => void;
}

export default function CompanyHeader({
  companyName,
  verified,
  onLogout,
  menuOpen,
  onMenu,
}: CompanyHeaderProps) {
  const t = useT();
  return (
    <header className="sticky top-0 z-30 border-b border-line-strong bg-white">
      {/* Phones: tighter spacing, compact logo, icon-only "Add a vehicle" so the row fits 360 px;
          under 360 px that button hides (Overview and My listings have it) so the row fits 300 px */}
      <div className="flex h-14 items-center gap-1.5 px-2.5 min-[360px]:gap-2 min-[360px]:px-3 sm:gap-4 sm:px-6">
        <SideNavButton open={menuOpen} onClick={onMenu} />
        <Link
          to="/"
          className="shrink-0 whitespace-nowrap text-xs font-semibold tracking-[0.15em] text-ink no-underline sm:text-sm sm:tracking-[0.3em]"
        >
          LE COIN VTC
        </Link>
        <span className="hidden truncate border-l border-line-strong pl-4 text-[13px] text-muted sm:block">
          {companyName}
        </span>
        {verified && (
          <span className="hidden whitespace-nowrap rounded bg-tone-green-bg px-1.75 py-0.75 text-[11px] font-medium text-tone-green-fg sm:inline">
            {t.common.verifiedCompany}
          </span>
        )}
        <LanguageSwitcher className="ml-auto" />
        <NotificationBell />
        <Link
          to="/company/listings/new"
          aria-label={t.company.header.addVehicle}
          className="hidden h-9 shrink-0 items-center whitespace-nowrap rounded bg-brand px-2.5 text-[13px] font-medium text-white no-underline transition-colors hover:bg-brand-dark min-[360px]:flex sm:px-3.5"
        >
          <Plus size={16} className="sm:hidden" aria-hidden="true" />
          <span className="hidden sm:inline">{t.company.header.addVehicle}</span>
        </Link>
        <AccountMenu name={companyName || getSession()?.name || ""} email={getSession()?.email} onLogout={onLogout} />
      </div>
    </header>
  );
}
